/**
 * Query policy for REST snapshots that are kept current by a WebSocket stream.
 *
 * Fetch once whenever the owning view mounts, then rely on stream updates for the
 * lifetime of that mount. Focus and network events must not create extra snapshot
 * traffic; an explicit invalidation can still force a recovery fetch when needed.
 */
export const snapshotAndUpdateQueryOptions = {
  staleTime: Infinity,
  gcTime: 30 * 60 * 1000,
  refetchOnMount: 'always',
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
} as const
